// import PerfectScrollbar from "perfect-scrollbar";

// if ($(".company-history__wrapper").length) {
//   var ps = new PerfectScrollbar(".company-history__wrapper");
// }

